import { fetcher } from "helpers/fetcher";

import { TUpdateScorecardClientReq, TUpdateScorecardClientRes } from "./types";
import { MANAGEMENT_ENDPOINTS } from "./endpoint";
import { API_HEADER } from "api/constants";

export const updateScorecardClient = async (
  payload: TUpdateScorecardClientReq
) => {
  return await fetcher<
    TUpdateScorecardClientRes,
    TUpdateScorecardClientReq["data"]
  >(MANAGEMENT_ENDPOINTS.UPDATE_SCORECARD_CLIENT, {
    headers: {
      [API_HEADER.BU_ID]: payload.idBu,
    },
    data: payload.data,
    urlData: payload.urlData,
  });
};

export const mutationUpdateScorecardClient = async (
  payload: TUpdateScorecardClientReq
) => {
  return (await updateScorecardClient(payload)).data;
};

mutationUpdateScorecardClient._key = (payload: TUpdateScorecardClientReq) => [
  MANAGEMENT_ENDPOINTS.UPDATE_SCORECARD_CLIENT.url,
  payload,
];
